import { getListReportDetailAPI, getListReportDetailExcelAPI } from '../../../api/report';
import { ParamsReport, ReportDetailState, ValueOptions } from '../../../types/report';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Constant } from '../../../config/constant';
import { toast } from 'react-toastify';

const limit_pagination: any = window.localStorage.getItem('limit_pagination');
const limitPagination = isNaN(Number(limit_pagination)) ? Constant.PAGE_SIZE : Number(limit_pagination);

const initialState = {
  listReport: [],
  loading: false,
  pagination: {
    total: 0,
    per_page: limitPagination,
    current_page: Constant.DEFAULT_PAGE,
    last_page: Constant.DEFAULT_PAGE,
  },
  listRoute: [],
  listTimeRoute: [{ value: '', label: 'Tất cả' }],
  total_price: 0,
  total_real_revenue: 0,
  total_promotion: 0,
  filter: {
    booking_date: 'false',
    from: '',
    to: '',
    route_id: '',
    depart_time: '',
    payment_method: '',
    office_id: undefined,
    options: '',
  },
} as ReportDetailState;

export const reportDetailCompanySlice = createSlice({
  name: 'reportDetailCompany',
  initialState,
  reducers: {
    setListAllRoutes(state, action) {
      state.listRoute = action.payload;
    },
    setFilterBookingDate(state, action: PayloadAction<string>) {
      state.filter.booking_date = action.payload;
    },
    setFilterRangeDate(state, action: PayloadAction<any>) {
      state.filter.from = action.payload?.[0];
      state.filter.to = action.payload?.[1];
    },
    setFilterRoute(state, action: PayloadAction<number | string>) {
      state.filter.route_id = action.payload;
    },
    setFilterDepartTime(state, action: PayloadAction<number | string>) {
      state.filter.depart_time = action.payload;
    },
    setFilterPaymentMethod(state, action: PayloadAction<string>) {
      state.filter.payment_method = action.payload;
    },
    setFilterOffice(state, action: PayloadAction<number | undefined>) {
      state.filter.office_id = action.payload;
    },
    setFilterOptions(state, action: PayloadAction<string>) {
      state.filter.options = action.payload;
    },
    setListTimeRoute(state, action: PayloadAction<ValueOptions[]>) {
      state.listTimeRoute = action.payload;
    },
    setPerPage(state, action: PayloadAction<number>) {
      state.pagination.per_page = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListReportDetailCompany.pending, (state) => {
        state.loading = true;
      })
      .addCase(getListReportDetailCompany.fulfilled, (state, action) => {
        state.loading = false;
        state.listReport = action?.payload?.data;
        state.pagination.total = action.payload?.pagination?.total;
        state.pagination.per_page = action.payload?.pagination?.per_page;
        state.pagination.last_page = action.payload?.pagination?.last_page;
        state.pagination.current_page = action.payload?.pagination?.current_page;
        state.total_real_revenue = action.payload?.total_real_revenue;
        state.total_price = action.payload?.total_price;
        state.total_promotion = action.payload?.total_promotion;
      })
      .addCase(getListReportDetailCompany.rejected, (state, action: any) => {
        const listErros = action?.payload?.response?.data?.errors;
        if (listErros) {
          Object.keys(listErros)?.forEach((fieldName) => {
            toast.error(`${[listErros[fieldName]]}`);
          });
        }
        state.loading = false;
      })
      .addCase(getListReportDetailCompanyExcel.pending, (state) => {})
      .addCase(getListReportDetailCompanyExcel.fulfilled, (state, action) => {})
      .addCase(getListReportDetailCompanyExcel.rejected, (state, action: any) => {
        const listErros = action?.payload?.response?.data?.errors;
        if (listErros) {
          Object.keys(listErros)?.forEach((fieldName) => {
            toast.error(`${[listErros[fieldName]]}`);
          });
        }
      });
  },
});

export const getListReportDetailCompany = createAsyncThunk(
  'ReportDetailCompany/getAll',
  async (params: ParamsReport, { dispatch, rejectWithValue }) => {
    try {
      const response = await getListReportDetailAPI(params);
      if (response) {
        return response?.data;
      }
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);

export const getListReportDetailCompanyExcel = createAsyncThunk(
  'ReportDetailCompany/getAllExcel',
  async (params: ParamsReport, { dispatch, rejectWithValue }) => {
    try {
      const response = await getListReportDetailExcelAPI(params);
      if (response) {
        return response?.data;
      }
    } catch (error: any) {
      return rejectWithValue(error);
    }
  },
);

export const {
  setPerPage,
  setListAllRoutes,
  setFilterBookingDate,
  setFilterRangeDate,
  setFilterRoute,
  setFilterDepartTime,
  setFilterPaymentMethod,
  setFilterOffice,
  setFilterOptions,
  setListTimeRoute,
} = reportDetailCompanySlice.actions;
